import React,{useState} from 'react'
import StudentAvatar from '../../assets/images/student-avatar.png';
import CameraIcon from '../../assets/images/camera.png';
import { StateUseContext } from '../../context/UserDetailContext';
import swal from 'sweetalert';
import { uploadProfile } from '../../actions/StudentAction';

const ProfileInfo = () => {
    const {userDetail,setUserDetail} = StateUseContext();
    const {id,name,form_num,course_name,profile_percentage,profile_picture} = userDetail !==undefined && userDetail

    const [profilePic, setProfilePic] = useState({name : 'profilePic', value : ''});
    const [profileImg,setProfileImg] = useState();
    const [loadingImg,setLoadingImg] = useState(false)

    const profileHandleChange = async(e) => {
        setLoadingImg(true)
        const filesValue = e.target.files;
        const formData = new FormData();
        formData.append('myImage',filesValue[0])
        formData.append('id',id)
        
        await uploadProfile(formData).then(res => {
         
            if (res.status) {
                setLoadingImg(false)
                setUserDetail({...userDetail,...res?.data})
                setProfileImg(res.profile_picture)
                swal('Profile picture uploaded successfully','','success')
            }
            else{
                setLoadingImg(false)
                swal('Something went wrong','','error')
            }
        
        })
        .catch(err => {
            console.log(err);
        })
    }

    const handleImgError = e => {
        e.target.src = StudentAvatar;
        // e.target.className = 'card-img-top logoImg_error'
      }

  return (
    <section className="about_user_profileWrap">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-md-8">
                    <div className="profile_pic_about_user">
                        <div className="profile_pic">
                            <input type="file" value={profilePic.value} accept="image/png, image/gif, image/jpeg" id="profileImg"
                                     onChange={e => profileHandleChange(e)}  className="d-none"/>
                            <label htmlFor="profileImg" className={loadingImg?'loading_profileImg':''}>
                                {loadingImg ? 'Uploading...' :
                                (profile_picture || profileImg) ? 
                                <img src={`${process.env.REACT_APP_API_URL}/public/profilepicture/${profileImg?profileImg:profile_picture}`} 
                                 onError={handleImgError}
                                alt="Student avatar" title='Change Picture'/>
                                :<img src={StudentAvatar}  alt="Profile avatar" title='Change Picture'/>
                                }
                            </label>
                            <img src={CameraIcon} htmlFor="profile_pic" alt="Camera icon" title='Change Picture'/>
                        </div>
                        <div className="about_userProfile">
                            <h5>{name}</h5>
                            <p>ALLEN Form NO. : {form_num}</p>
                            <p className="badge-custom-course bg-info">Course : {course_name}</p>

                            <div className="widget-content-outer w-100">
                            <div className="widget-content-wrapper">
                                <div className="widget-content-left pr-2 fsize-1">
                                    <span className="widget-numbers fw-bold mt-0 fsize-3 text-primary">
                                        Profile Completion : {profile_percentage}%</span>
                                </div>
                                <div className="widget-content-right w-100 mt-2">
                                    <div className="progress-bar-xs progress">
                                        <div className="progress-bar bg-secondary" role="progressbar"
                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"
                                            style={{width : profile_percentage+ '%'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                        </div>

                        
                        
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="profile_right_col d-flex flex-wrap align-items-center justify-content-evenly">
                        {/* <div className="inner_item text-center">
                            <h3 className="fw-bold">04</h3>
                            <p>Exam</p>
                        </div>
                        <div className="inner_item text-center">
                            <h3 className="fw-bold">12</h3>
                            <p>Transaction</p>
                        </div>
                        <div className="inner_item text-center">
                            <h3 className="fw-bold">0</h3>
                            <p className="mb-0">Add Siblings</p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
     </section>
  )
}

export default ProfileInfo